import { ChevronDown } from 'lucide-react'

export default function CompanySelector({ companies, selected, onChange }) {
  return (
    <div className="relative" style={{ minWidth: '160px', maxWidth: '260px' }}>
      <select
        value={selected}
        onChange={(e) => onChange(e.target.value)}
        className="w-full appearance-none border border-[#77726e]/40 bg-[#f6f3ee] px-3 py-1.5 pr-8 text-sm text-[#2f3126] font-semibold focus:outline-none focus:ring-2 focus:ring-[#4e6498]/30 focus:border-[#4e6498] truncate"
        title={selected}
      >
        {companies.map((company) => (
          <option key={company} value={company}>{company}</option>
        ))}
      </select>
      <ChevronDown className="absolute right-2 top-1/2 -translate-y-1/2 w-4 h-4 text-[#77726e] pointer-events-none" />
    </div>
  )
}
